import { Route, Routes } from 'react-router-dom';
import { NotFound } from 'src/routes/NotFound';
import { Blog } from './Blog';
import { BlogDetail } from './BlogDetail';

const BlogViews = () => {
    return (
        <Routes>
            <Route path="/" element={<Blog />} />
            <Route path="/:slug" element={<BlogDetail />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

export { BlogViews };
